'use strict';

require('./hysdk.fusion');

var sdk = require('./hysdk');
var isCtripApp = userAgent.indexOf("_CtripWireless") > -1;
var eventName = 'WebViewJavascriptBridgeReady';
var custEvent = require('../plugins/ctrip/lib/custEvent');
var hyAPIS = require('../src/apis/');
var ctripAPIS = require('../plugins/ctrip/apis/');

if (isCtripApp) {

    var mapping = {},
        ctrip = sdk.ctrip,
        WebViewJavascriptBridge = window.WebViewJavascriptBridge = {
        invoke: function invoke(key, callback, opt) {
            var conf = mapping[key];
            if (conf) {
                if (conf.exec) {
                    conf.exec.call(sdk, opt, callback);
                } else {
                    if (conf.optHandle) {
                        opt = conf.optHandle(opt || {});
                    }
                    sdk.bridge.invoke(conf.service, conf.action, opt, conf.tagname, function (res) {
                        var rs = conf.resHandle ? conf.resHandle(res, opt) : res;
                        // 模拟 hide
                        if (api === 'openWebView' || api === 'openWindow') {
                            sdk.ctrip.trigger('hide');
                        }
                        rs._originData = res;
                        callback(rs);
                    });
                }
            } else {
                callback({
                    ret: false,
                    errcode: 10001,
                    errmsg: "API not exist!"
                });
            }
        },
        on: ctrip.on.bind(ctrip),
        once: ctrip.once.bind(ctrip),
        off: ctrip.off.bind(ctrip)
    };

    Object.keys(hyAPIS).forEach(function (name) {
        if (ctripAPIS[name] && hyAPIS[name].hy) {
            mapping[hyAPIS[name].hy.key || name] = ctripAPIS[name];
        }
    });

    sdk.config({
        wechatSupport: false
    });

    sdk.ready(function () {
        var m_document_addEventListener = document.addEventListener,
            readyEvent = document.createEvent('Events');

        readyEvent.initEvent(eventName);
        readyEvent.bridge = WebViewJavascriptBridge;
        document.addEventListener = function (evt, handler, capture) {
            var e = evt.toLowerCase();
            if (e === eventName.toLowerCase()) {
                handler(readyEvent);
            } else {
                m_document_addEventListener.call(document, evt, handler, capture);
            }
        };
        document.dispatchEvent(readyEvent);
    });
}

module.exports = sdk;


//////////////////
// WEBPACK FOOTER
// ./hysdk.webViewJavascriptBridge.js
// module id = 62
// module chunks = 4